export default __webpack_public_path__ + "static/media/revolosio_sword.5500a568.bmp";